import { MenuCat } from 'earn-ts/build/rust';
import { useState, useEffect, useRef } from 'react';
import { pickName } from 'src/utils';

interface IHeaderPageProps {
  listTab: MenuCat[];
  currentCategory: string;
  handleChangeTab: (item: string) => void;
  lang: string;
}

const Tab = ({
  listTab,
  handleChangeTab,
  currentCategory,
  lang,
}: IHeaderPageProps) => {
  const checkActiveTab = (itemTab: string | null) => {
    return itemTab === currentCategory;
  };

  const tabsRef = useRef<HTMLDivElement>(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  useEffect(() => {
    if (!tabsRef.current || !isDragging) return;

    const handleMouseMove = (event: MouseEvent) => {
      const x = event.clientX - startX;
      tabsRef.current!.scrollLeft = scrollLeft - x;
    };

    const handleMouseUp = () => {
      setIsDragging(false);
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isDragging, startX, scrollLeft]);

  const handleMouseDown = (event: React.MouseEvent<HTMLDivElement>) => {
    if (!tabsRef.current) return;

    setIsDragging(true);
    setStartX(event.clientX);
    setScrollLeft(tabsRef.current.scrollLeft);
  };

  return (
    <div className="w-full overflow-x-auto" ref={tabsRef}>
      <div
        className="flex flex-row space-x-3 px-3"
        onMouseDown={handleMouseDown}>
        {listTab.map((item, index) => (
          <button
            onClick={() => handleChangeTab(item.id)}
            className={`text-[14px] px-1.5 py-1 text-center whitespace-nowrap ${
              checkActiveTab(item.id)
                ? 'border-b border-primary border-solid border-b-2 font-bold'
                : ''
            }`}
            key={item.id}>
            <span className="block">{pickName(item, lang)}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default Tab;
